import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.js';
import '@cyrusagents/design-system/styles.css';
import './style.css';
import '@xterm/xterm/css/xterm.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
